
import { defineComponent, PropType } from 'vue'

export interface V2Invoice {
  id: string
  date: string
  amount: number
  status: string
  url: string
}

export default defineComponent({
  name: 'V2RecentInvoices',
  props: {
    invoices: {
      type: Array as PropType<V2Invoice[]>,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    statusColor(status: string): string {
      switch (status) {
        case 'Paid':
          return 'juniper'
        case 'Open':
          return 'aqua'
        case 'Draft':
          return 'vanilla'
        case 'Void':
        case 'Uncollectible':
          return 'cherry'
        default:
          return 'vanilla'
      }
    }
  }
})
